export default __webpack_public_path__ + "static/media/course-in-progress.b950a297.svg";